import * as Sentry from '@sentry/nextjs';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import QUERY_COMPANIES_LOGOS from '../graphql/HomepageCompaniesByCountry.v4.graphql';

import {
  HomepageCompaniesByCountry,
  HomepageCompaniesByCountryVariables,
  HomepageCompaniesByCountry_companyByCountry_companies as CompaniesLogos,
} from '../graphql/types/HomepageCompaniesByCountry';

const getCompaniesLogos = async (
  apolloClient: ApolloClient<NormalizedCacheObject>,
  countryCode: string,
) => {
  try {
    const { data } = await apolloClient.query<
      HomepageCompaniesByCountry,
      HomepageCompaniesByCountryVariables
    >({
      query: QUERY_COMPANIES_LOGOS,
      context: {
        clientName: 'v4',
      },
      variables: {
        countryCode: countryCode || '',
      },
    });

    const companiesLogos: CompaniesLogos[] = [];

    if (
      data &&
      data.companyByCountry?.length &&
      data.companyByCountry[0]?.companies
    ) {
      data.companyByCountry[0]?.companies.forEach(company => {
        if (company?.id) {
          companiesLogos.push(company);
        }
      });
      return companiesLogos;
    }
    throw new Error('companyByCountry query has failed');
  } catch (error) {
    console.error(error);
    Sentry.captureException(error, {
      extra: {
        query: 'Homepage_companyByCountry',
      },
    });
    return null;
  }
};

export default getCompaniesLogos;
